import { IPeriodOption } from '../../../models/qbr/iQbrQuarter'
import { IMappedPeriodOption } from '../models/mappedPeriod'

export const mapToPeriodOption = (option: IMappedPeriodOption): IPeriodOption => {
  return {
    FYear: option.fYear,
    Enabled: option.isEnabled ? 1 : 0,
    FQuarters: option.fQuarters.map((it) => ({
      FQuarter: it.fQuarter,
      Enabled: it.isEnabled ? 1 : 0,
    })),
  }
}
